import { Component, Input, OnChanges, OnInit, ViewContainerRef } from '@angular/core';
import { AuxiliaryDataFieldSchemaInterface, AuxiliaryDataFieldType } from '@vendasta/account-group';
import { FilterHandler } from '../auxiliary-data-accounts-table-filters.service';
import { CurrencyFilterHandler } from './currency-filter-render.component';
import { DatetFilterHandler } from './date-filter-render.component';
import { DropdownFilterHandler } from './dropdown-filter-render.component';
import { IntegerFilterHandler } from './integer-filter-render.component';
import { TextFilterHandler } from './text-filter-render.component';

@Component({
  standalone: true,
  selector: 'aux-renderer-selector',
  template: '<ng-container></ng-container>',
})
export class RendererSelectorComponent implements OnInit, OnChanges {
  @Input() handler!: FilterHandler;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnInit(): void {
    this.handler?.render(this.viewContainerRef);
  }

  ngOnChanges(): void {
    this.handler?.render(this.viewContainerRef);
  }
}

export function chooseHandler(fieldSchema: AuxiliaryDataFieldSchemaInterface): FilterHandler {
  switch (fieldSchema.fieldType) {
    case AuxiliaryDataFieldType.AUXILIARY_DATA_FIELD_TYPE_STRING:
      return new TextFilterHandler(fieldSchema);
    case AuxiliaryDataFieldType.AUXILIARY_DATA_FIELD_TYPE_INTEGER:
      return new IntegerFilterHandler(fieldSchema);
    case AuxiliaryDataFieldType.AUXILIARY_DATA_FIELD_TYPE_DATE:
      return new DatetFilterHandler(fieldSchema);
    case AuxiliaryDataFieldType.AUXILIARY_DATA_FIELD_TYPE_DROPDOWN:
      return new DropdownFilterHandler(fieldSchema);
    case AuxiliaryDataFieldType.AUXILIARY_DATA_FIELD_TYPE_CURRENCY:
      return new CurrencyFilterHandler(fieldSchema);
    default:
      console.warn(`Custom field filter could not handle type ${fieldSchema.fieldType}`);
      return null;
  }
}
